'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = eauors;
var _d = require('d3');
var _d2 = _interopRequireDefault(_d);
var _ramda = require('ramda');
var _utils = require('../utils/');
var _constants = require('../utils/constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function annotationDatapointBaseline() {
  var element = _d2.default.select(this);
  var offset = (0, _utils.fontBaselineOffset)(element, _constants.TEXT_ABOVE);
  return 'translate(0, ' + offset + ')';
}
function annotationDatapointEnter(selection, selector) {
  (0, _utils.setupElement)(selection, 'svg:text', selector);
}
function annotationDatapointUpdate(selection, options, accessors, scales, color) {
  selection.text((0, _ramda.curry)(accessors.annotationDatapoint)(options.serie.annotation)).attr({
    x: function x(datum) {
      return scales.xScale(accessors.x(datum));
    },
    y: function y(datum) {
      return scales.yScale(accessors.y(datum));
    }
  }).style((0, _extends3.default)({}, (0, _utils.fontStyle)(options.serie.annotation.font), {
    fill: color,
    'text-anchor': _constants.TEXT_MIDDLE,
    'text-shadow': '1px 1px 0 ' + options.background.color + ', 0 0 2px ' + options.background.color,
    opacity: 1
  }));

  // after first rendering to have the correct height
  selection.attr({
    transform: annotationDatapointBaseline
  });
}
function lineEnter(selection, _, selector) {
  return (0, _utils.setupElement)(selection, 'svg:path', selector);
}
function lineOver(options, selectors, accessors, scales, serieData) {
  var color = (0, _utils.getOverColor)(options.serie, accessors.focusData(serieData));
  var serie = _d2.default.select(this.parentNode.parentNode);
  serie.selectAll((0, _utils.selector)(selectors.subSerie)).selectAll((0, _utils.selector)(selectors.line)).style({
    stroke: color,
    'stroke-width': options.serie.line.focused.thickness
  });
  if (!accessors.isCondensed(options.serie, serie.datum(), scales.xScale)) {
    serie.selectAll((0, _utils.selector)(selectors.subSerie)).selectAll((0, _utils.selector)(selectors.marker)).style({
      fill: color,
      opacity: 1
    });
    if (options.serie.annotation.display !== _constants.NEVER) {
      var annotations = serie.selectAll((0, _utils.selector)(selectors.subSerie)).selectAll((0, _utils.selector)(selectors.annotationDatapoint)).data(accessors.datapoints);
      annotations.enter().call(annotationDatapointEnter, selectors.annotationDatapoint);
      annotations.call(annotationDatapointUpdate, options, accessors, scales, color);
    }
  }
}
function lineOut(options, selectors, accessors, scales, serie) {
  var color = (0, _utils.getColor)(options.serie, accessors.focusData(serie));
  var allSerie = _d2.default.select(this.parentNode.parentNode);
  allSerie.selectAll((0, _utils.selector)(selectors.line)).style({
    stroke: color,
    'stroke-width': function strokeWidth(serie) {
      return accessors.isFocused(serie) ? options.serie.line.focused.thickness : options.serie.line.thickness;
    }
  });
  if (!accessors.isCondensed(options.serie, allSerie.datum(), scales.xScale)) {
    allSerie.selectAll((0, _utils.selector)(selectors.subSerie)).filter(function (serie) {
      return (0, _ramda.length)(serie.datapoints) > 1;
    }).selectAll((0, _utils.selector)(selectors.marker)).style({
      fill: color,
      opacity: accessors.isFocused(serie) ? 1 : 0
    });
    allSerie.selectAll((0, _utils.selector)(selectors.subSerie)).selectAll((0, _utils.selector)(selectors.annotationDatapoint)).style({
      opacity: 0
    });
  }
  allSerie.selectAll((0, _utils.selector)(selectors.subSerie)).filter(function (serie) {
    return (0, _ramda.length)(serie.datapoints) === 1;
  }).selectAll((0, _utils.selector)(selectors.marker)).style({
    fill: color,
    opacity: 1
  });
}
function lineUpdate(selection, options, selectors, accessors, _ref) {
  var xScale = _ref.xScale,
    yScale = _ref.yScale;
  var line = _d2.default.svg.line().x(function (datum) {
    return xScale(accessors.x(datum));
  }).y(function (datum) {
    return yScale(accessors.y(datum));
  });
  selection.attr('d', function (serie) {
    return line(accessors.datapoints(serie));
  }).style({
    stroke: function stroke(serie) {
      return (0, _utils.getColor)(options.serie, accessors.focusData(serie));
    },
    'stroke-width': function strokeWidth(serie) {
      return accessors.isFocused(serie) ? options.serie.line.focused.thickness : options.serie.line.thickness;
    },
    fill: _constants.NONE
  }).on('mouseover', (0, _ramda.curry)(lineOver)(options, selectors, accessors, {
    xScale: xScale,
    yScale: yScale
  })).on('mouseout', (0, _ramda.curry)(lineOut)(options, selectors, accessors, {
    xScale: xScale,
    yScale: yScale
  }));
}
function hoverlineEnter(selection, options, selectors) {
  lineEnter(selection, options, selectors.hoverline);
}
function hoverlineUpdate(selection, options, selectors, accessors, scales) {
  lineUpdate(selection, options, selectors, accessors, scales);
  selection.style({
    stroke: 'black',
    'stroke-width': options.serie.line.shadow,
    opacity: 0
  });
}
function markerEnter(selection, selectors, hideTooltip) {
  (0, _utils.setupElement)(selection, 'svg:path', selectors.marker).on('mouseleave', (0, _ramda.curry)(hideTooltip));
}
function markerUpdate(selection, options, selectors, accessors, _ref2, showTooltip) {
  var xScale = _ref2.xScale,
    yScale = _ref2.yScale;
  selection.attr({
    d: _d2.default.svg.symbol().type(options.serie.line.marker.shape).size(30),
    transform: function transform(datum) {
      return 'translate(' + xScale(accessors.x(datum)) + ', ' + yScale(accessors.y(datum)) + ')';
    }
  }).style({
    opacity: function opacity() {
      var serieData = _d2.default.select(this.parentNode.parentNode).datum();
      var subSerieData = _d2.default.select(this.parentNode).datum();
      var isAlone = (0, _ramda.length)(accessors.datapoints(subSerieData)) === 1;
      var isFocused = accessors.isFocused(serieData);
      var isCondensed = accessors.isCondensed(options.serie, serieData, xScale);
      return isFocused && !isCondensed || isAlone ? 1 : 0;
    },
    fill: function fill() {
      return (0, _utils.getColor)(options.serie, accessors.focusData(_d2.default.select(this.parentNode).datum()));
    },
    stroke: options.background.color,
    'stroke-width': options.serie.line.marker.shadow
  }).on('mouseover', function () {
    var serie = _d2.default.select(this.parentNode.parentNode);
    var hoverline = serie.select((0, _utils.selector)(selectors.hoverline)).node();
    (0, _ramda.bind)(lineOver, hoverline)(options, selectors, accessors, {
      xScale: xScale,
      yScale: yScale
    }, serie.datum());
    if (accessors.isCondensed(options.serie, serie.datum(), xScale)) {
      _d2.default.select(this).style({
        opacity: 1,
        fill: function fill() {
          return (0, _utils.getOverColor)(options.serie, accessors.focusData(serie.datum()));
        }
      });
    }
  }).on('mousemove', function (datum) {
    var subSerieData = _d2.default.select(this.parentNode).datum();
    var color = (0, _utils.getOverColor)(options.serie, accessors.focusData(subSerieData));
    showTooltip(options.serie, {
      xScale: xScale,
      yScale: yScale
    }, subSerieData, datum, color);
  }).on('mouseout', function () {
    var serie = _d2.default.select(this.parentNode.parentNode);
    var hoverline = serie.select((0, _utils.selector)(selectors.hoverline)).node();
    (0, _ramda.bind)(lineOut, hoverline)(options, selectors, accessors, {
      xScale: xScale,
      yScale: yScale
    }, serie.datum());
    if (accessors.isCondensed(options.serie, serie.datum(), xScale)) {
      var subSerieData = _d2.default.select(this.parentNode).datum();
      _d2.default.select(this).style({
        opacity: (0, _ramda.length)(accessors.datapoints(subSerieData)) > 1 ? 0 : 1,
        fill: function fill() {
          return (0, _utils.getColor)(options.serie, accessors.focusData(subSerieData));
        }
      });
    }
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    lineEnter: lineEnter,
    lineUpdate: lineUpdate,
    hoverlineEnter: hoverlineEnter,
    hoverlineUpdate: hoverlineUpdate,
    markerEnter: markerEnter,
    markerUpdate: markerUpdate
  });
}